import { api } from '../../lib/api';
import type { useDialog } from '../../components/DialogProvider';
import type { useToast } from '../../components/Toast';

/**
 * Apagar um contato de vez — a peca UNICA das duas lixeiras (campanha de fly e aba Contatos).
 * Nasceu na campanha em 24/09/2026 e saiu pra ca no mesmo dia, quando ele pediu a lixeira tambem
 * na aba Contatos.
 *
 * Antes de apagar, le a previa do servidor (`GET /exclusao`): o que vai junto e o que impede. Quem
 * decide o que pode e' o SERVIDOR — so' numero invalido, sem mensagem, sem orcamento, sem App, so'
 * admin ([DA-753] p.6 e a regra dele de 24/09). Aqui a tela so' mostra o motivo em palavras e pede
 * a confirmacao.
 *
 * Devolve `true` quando apagou, pra quem chamou recarregar a lista.
 */
export async function excluirContatoDeVez(
  contatoId: number,
  dialog: ReturnType<typeof useDialog>,
  toast: ReturnType<typeof useToast>,
): Promise<boolean> {
  try {
    const p = await api.get<{
      nome: string | null; telefone: string | null; conversas: number; mensagens: number;
      etiquetas: number; impedimentos: string[];
    }>('/api/contatos/' + contatoId + '/exclusao');
    if (p.impedimentos.length) {
      await dialog.alerta(
        'Este contato não pode ser apagado:\n\n• ' + p.impedimentos.join('\n• '),
        { titulo: 'Não dá para apagar' },
      );
      return false;
    }
    const ok = await dialog.confirmar(
      'Apagar de vez "' + (p.nome || 'sem nome') + '" (' + (p.telefone || 'sem número') + ')?\n\n'
        // Com mensagem so' chega aqui o fly que nunca chegou ao celular (a trava barra o resto) —
        // "vazia" seria afirmacao falsa, entao o texto nomeia o que vai junto.
        + 'Vai junto: ' + p.etiquetas + ' etiqueta(s) e ' + p.conversas + ' conversa(s) '
        + (p.mensagens > 0 ? 'com ' + p.mensagens + ' fly(s) que nunca chegaram ao celular. ' : 'vazia(s). ')
        + 'Ele sai de todas as telas e campanhas.\n\nNão tem como desfazer.',
      { titulo: 'Apagar contato?', textoConfirmar: 'Apagar', perigoso: true },
    );
    if (!ok) return false;
    await api.delete('/api/contatos/' + contatoId + '/definitivo');
    toast.sucesso('Contato apagado');
    return true;
  } catch (e) {
    await dialog.alerta((e as Error).message || 'Não foi possível apagar', { titulo: 'Não apagou' });
    return false;
  }
}
